/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Card, Row, Col, Badge, Modal, Button } from 'antd';
import Img from "react-image";
import { getTranslate } from "react-localize-redux";
import classNames from "classnames";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getSchemes, openOrClosePromoDetailsModal, getNextPageSchemes } from "reducers/promotions";
import placeholderImg from "assets/img/banner-placeholder.png";
import NoData from "components/reusable/NoData";
import { Spinner } from "components/Spinner";
import PromoDetailsAndProducts from "./PromoDetailsAndProducts";
import { ImageLoader } from "components/Spinner";
import Constants from "utilities/appConstants";
import { GAShowMoreButton } from "hooks/googleAnalyticsHooks";
import ScrollTop from "components/reusable/ScrollTop";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Meta } = Card;

/* Get the noSchemeImageBannerColorSequence from global window object */
const { noSchemeImageBannerColorSequence } = window;
/* Const,Let & Var will be here */

class PromotionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSchemeId: 0,
      isMobileView: window.innerWidth <= 992 ? true : false
    }

    /* Get the promotion list */
    this.getAllPromotionList();
  }

  getAllPromotionList = () => {
    const { category, subcategory } = this.props.params || { category: '', subcategory: '' };
    const requestObj = {
      FilterLevelCode: "",
      Ids: [],
      Page: 1,
      requestPageType: this.props.requestPageType
    };

    if (this.props.productId !== undefined) {
      requestObj.FilterLevelCode = "SKU";
      requestObj.Ids = [this.props.productId];
    }
    else if (subcategory) {
      const splittedSubCat = subcategory.split("_");
      const subCatId = splittedSubCat[splittedSubCat.length - 1];

      if (subCatId) {
        requestObj.FilterLevelCode = "SUCAT";
        requestObj.Ids = [parseInt(subCatId, 10)];
      }
    }
    else if (category) {
      const splittedCat = category.split("_");
      const catId = splittedCat[splittedCat.length - 1];

      if (catId) {
        requestObj.FilterLevelCode = "CAT";
        requestObj.Ids = [parseInt(catId, 10)];
      }
    }

    this.props.actions.getSchemes(requestObj);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.productId !== undefined && this.props.productId !== prevProps.productId) {
      /* Get the promotion list */
      this.getAllPromotionList();
    }
  }

  showPromotionDetails = (schemeId) => {
    this.setState({ selectedSchemeId: schemeId });
    this.props.actions.openOrClosePromoDetailsModal(true);
  }

  closePromoDetails = () => {
    this.setState({ selectedSchemeId: 0 });
    this.props.actions.openOrClosePromoDetailsModal(false);
  }

  /* Get scheme image */
  getSchemeCover = (scheme, index) => {
    if (scheme.ImageUrl && scheme.ImageUrl !== "") {
      return (
        <Img
          className="promotion-card-image-fit" alt=""
          src={[scheme.ImageUrl, placeholderImg]}
          loader={<ImageLoader />}
        />
      );
    }
    else {
      return (
        <div
          className="promotion-card-image-fit promotion-color-banner overflow-auto"
          style={{ "backgroundColor": this.getBackgroundColor(index) }}>
          <h6 className="banner-text-truncate scheme-image-scheme-name">{scheme.Narration}</h6>
        </div >
      );
    }
  }

  /* Get dynamic background color for promotion banner */
  getBackgroundColor = (index) => {
    return index % 2 === 0
      ? noSchemeImageBannerColorSequence[1]
      : noSchemeImageBannerColorSequence[0];
  };

  componentDidMount = () => {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ isMobileView: window.innerWidth <= 992 ? true : false });
  }

  /* Display only 4 promotions in mobile view and 6 promotions in web view in the offer zone - home page */
  getPromotionArrayBasedOnPageType = () => {
    if (this.props.requestPageType === Constants.OFFER_ZONE)
      return this.props.promotions.promotionList.slice(0, this.state.isMobileView ? 4 : 6);
    else
      return this.props.promotions.promotionList;
  }

  /* Handle show more button click */
  showMorePromotions = () => {
    this.props.actions.getNextPageSchemes(this.props.promotions.filter.Page + 1);

    /* GA - track show more product event */
    if (window.isEnableGA)
      GAShowMoreButton(Constants.SCHEME_LIST);
  }

  renderComp = () => {
    const { translate, requestPageType, promotions, appSettings } = this.props;

    if (promotions.isPromoListLoading && promotions.promotionList.length === 0) {
      return (
        <div className="container pt-5">
          <Spinner message={translate("promotion.loading.promotionList")} />
        </div>
      );
    }
    else if (promotions.promotionList.length > 0) {
      return (
        <React.Fragment>
          <div className={classNames('container', { 'pl-0 pr-0 mt-2': (requestPageType === Constants.PRODUCT_DETAILS) })}>

            {/* Total promotion count badge */}
            {requestPageType !== Constants.OFFER_ZONE && requestPageType !== Constants.PRODUCT_DETAILS &&
              <div className="responsive-font-size">
                {translate("promotion.totalPromotions")}
                <Badge className="ant-badge-green ml-1" showZero overflowCount={999} count={promotions.count} />
              </div>
            }

            <Row className="pb-4">
              {this.getPromotionArrayBasedOnPageType().map((scheme, index) => (
                <Col xs={(requestPageType === Constants.OFFER_ZONE || requestPageType === Constants.PRODUCT_DETAILS) ? 12 : 24}
                  sm={(requestPageType === Constants.OFFER_ZONE || requestPageType === Constants.PRODUCT_DETAILS) ? 12 : 24}
                  md={12}
                  lg={8}
                  xl={8}
                  className="pt-2 pr-2 pl-2 p-2"
                  key={scheme.Id}
                  onClick={() => this.showPromotionDetails(scheme.Id)}
                >
                  <Badge.Ribbon text={translate("products.productLabel.promotion")} color="#ff6b35" placement="start">
                    <Card
                      className="promotion-card-shadow promo-list-card"
                      hoverable
                      cover={
                        <div className="promotion-card-image-fit">
                          {this.getSchemeCover(scheme, index)}
                        </div>
                      }
                    >
                      <Meta className="scheme-name-wrap-three-line" title={scheme.Name} />

                      <Row gutter={[8, 8]} className="responsive-font-size">
                        <Col span={(requestPageType === Constants.OFFER_ZONE || requestPageType === Constants.PRODUCT_DETAILS) ? 24 : 12} md={12}>
                          <Badge status="success" />
                          {translate("promotion.start")} : {scheme.StartDate}</Col>
                        <Col span={(requestPageType === Constants.OFFER_ZONE || requestPageType === Constants.PRODUCT_DETAILS) ? 24 : 12} md={12}>
                          <Badge status="error" />
                          {translate("promotion.end")} : {scheme.EndDate}</Col>
                      </Row>
                    </Card>
                  </Badge.Ribbon>
                </Col>
              ))}
            </Row>
          </div>

          {/* Product list show more */}
          {(requestPageType !== Constants.OFFER_ZONE && promotions.promotionList.length > 0 && promotions.totalCount > promotions.noOfItemsReceived && promotions.IsShowShowMoreProductButton) &&
            <div className="mt-3 w-100">
              {promotions.isPromoListLoading ?
                <Spinner message={translate("promotion.loading.promotionList")} />
                :
                <div className="text-center">
                  <Button type="primary" shape="round" onClick={this.showMorePromotions}>{translate("promotion.showMorePromotions")}</Button>
                </div>
              }
            </div>
          }

          {/* Promotion Details Modal */}
          {this.props.promotions.isShowPromoDetailsModal && this.state.selectedSchemeId !== 0 &&
            <Modal
              title={translate("promotion.schemeDetails")}
              footer={null}
              onCancel={() => this.closePromoDetails()}
              centered
              width={1300}
              closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
              visible={this.props.promotions.isShowPromoDetailsModal}
              className="promo-details-model"
              maskClosable={false}
            >
              <PromoDetailsAndProducts pageType={requestPageType} promoDetailsPageType={Constants.SCHEME_LIST} schemeId={this.state.selectedSchemeId} />
            </Modal>
          }

          {requestPageType !== Constants.OFFER_ZONE && requestPageType !== Constants.PRODUCT_DETAILS && appSettings.isEnableScrollToTop &&
            <div className='scroll-top-position'>
              <ScrollTop />
            </div>
          }
        </React.Fragment>
      )
    }
    else {
      return (
        <NoData isFromSmallSection={requestPageType === Constants.OFFER_ZONE ? true : false} NoDataMessage={translate("promotion.noData.promotionList")} />
      );
    }
  }

  render() { return (this.renderComp()) }
}

const mapStateToProps = (state, ownProps) => {
  const promotionsState =
    ownProps.requestPageType === Constants.PRODUCT_DETAILS
      ? state.promotions.details
      : state.promotions.list;

  return {
    promotions: promotionsState || { promotionList: [] },
    appSettings: state.appSettings,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        getSchemes,
        openOrClosePromoDetailsModal,
        getNextPageSchemes
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionList);